import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "../../globalStyle";
import { navbar } from "../../utils/navbar";
import {
  Icon,
  Link,
  LinksWrapper,
  Logo,
  MyNavImg,
  NavbarWrapper,
} from "./style";

export const Navbar = () => {
  const [sticky, setSticky] = useState(false);

  const navRef = useRef();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 20) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    });
  }, []);

  return (
    <Container>
      <NavbarWrapper ref={navRef} sticky={sticky}>
        <Logo to={"/"}>Sardor</Logo>
        <LinksWrapper>
          {navbar.map((v) => {
            return (
              <Link key={v.id} to={v.path}>
                <Icon>{v.icon}</Icon>
                {v.title}
              </Link>
            );
          })}
        </LinksWrapper>
        <MyNavImg />
      </NavbarWrapper>
      <Outlet />
    </Container>
  );
};
